import Model from "./Model";
import Payment from "./Payment";

export default class Deposit extends Model {
    resource() {
        return "deposits";
    }

    relations() {
        return {
            payments: Payment
        };
    }

    primaryKey() {
        return "uuid";
    }

    async refresh() {
        const { data } = await this.$http.get(this.endpoint() + "?refresh");
        return new Deposit(data.data);
    }
}